import React from 'react';
import './columns.css';
import iconInspection from '../../assets/qfc_icon_inspection.svg';
import iconOperation from '../../assets/qfc_icon_operation.svg';
import iconQuality from '../../assets/qfc_icon_quality.svg';
import iconTime from '../../assets/qfc_icon_time.svg';
import { useTranslation } from 'react-i18next';

const LandingSection = () => {
	const { t } = useTranslation();
	
  return (
    <div className="container">
		<div className="columns">
			<div className="circle_column">
				<div className="circle">
					<img src={iconOperation} alt="Få överblick & kontroll" className="feature-image" />
				</div>
				<div className="texts">
					<h4>{t('overview.usp1.title')}</h4>
					<p>{t('overview.usp1.description')}</p>
				</div>
			</div>
			<div className="circle_column">
				<div className="circle">
					<img src={iconTime} alt="Spara tid & pengar" className="feature-image" />
				</div>
				<div className="texts">
					<h4>{t('overview.usp2.title')}</h4>
					<p>{t('overview.usp2.description')}</p>
				</div>
			</div>
			<div className="circle_column">
				<div className="circle">
					<img src={iconQuality} alt="Håll dig trygg & säker" className="feature-image" />
				</div>
				<div className="texts">
					<h4>{t('overview.usp3.title')}</h4>
					<p>{t('overview.usp3.description')}</p>
				</div>
			</div>
			<div className="circle_column">
				<div className="circle">
					<img src={iconInspection} alt="Alltid redo för inspektion" className="feature-image" />
				</div>
				<div className="texts">
					<h4>{t('overview.usp4.title')}</h4>
					<p>{t('overview.usp4.description')}</p>
				</div>
			</div>
		</div>
    </div>
  );
};

export default LandingSection;
